import { atom } from "recoil";

export const dashboardDataAtom = atom<any[]>({
    key: "dashboardDataAtom",
    default: [],
});